import Router from './Router';

function App() {
  return (
    <div className="tailwindcss-wrapper tw-min-h-[calc(100vh-184px)] tw-bg-white">
      <Router />
    </div>
  );
}

export default App;
